var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRestartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9993 25.3334C13.3938 25.3334 11.1868 24.4292 9.37852 22.6209C7.57018 20.8126 6.66602 18.6056 6.66602 16.0001C6.66602 13.3945 7.57018 11.1876 9.37852 9.37925C11.1868 7.57091 13.3938 6.66675 15.9993 6.66675C17.341 6.66675 18.6243 6.94364 19.8493 7.49741C21.0743 8.05119 22.1243 8.84375 22.9993 9.87508V6.66675H25.3327V14.8334H17.166V12.5001H22.066C21.4438 11.4112 20.5933 10.5556 19.5145 9.93341C18.4357 9.31119 17.264 9.00008 15.9993 9.00008C14.0549 9.00008 12.4021 9.68064 11.041 11.0417C9.6799 12.4029 8.99935 14.0556 8.99935 16.0001C8.99935 17.9445 9.6799 19.5973 11.041 20.9584C12.4021 22.3195 14.0549 23.0001 15.9993 23.0001C17.4966 23.0001 18.848 22.5723 20.0535 21.7167C21.2591 20.8612 22.1049 19.7334 22.591 18.3334H25.041C24.4966 20.3945 23.3882 22.0765 21.716 23.3792C20.0438 24.682 18.1382 25.3334 15.9993 25.3334Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestartIcon);
export default __webpack_public_path__ + "static/media/restart-icon.54462e10b49ba80c8cb79e29d5385c3c.svg";
export { ForwardRef as ReactComponent };